import { RootState } from 'redux/store'

export const termsSectionsSelector = (state: RootState) =>
  state.termsReducer.termsSections
